export const ServerHost = "https://" + process.env.REACT_APP_XKK_SERVER;